
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductBOMSelectGrid extends Serenity.EntityGrid<ProductBOMRow, any> {
        protected getColumnsKey() { return 'OMS.ProductBOM'; }
        protected getDialogType() { return <any>ProductBOMDialog; }
        protected getIdProperty() { return ProductBOMRow.idProperty; }
        protected getLocalTextPrefix() { return ProductBOMRow.localTextPrefix; }
        protected getService() { return ProductBOMService.baseUrl; }
        //protected getInsertPermission() { return ProductBOMRow.insertPermission; }
        //protected getUpdatePermission() { return ProductBOMRow.updatePermission; }
        //protected getDeletePermission() { return ProductBOMRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            return this;
        }

        get selectedItems(): ProductBOMRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProductBOMs && this.options.hideProductBOMs.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["BOMProductId" /* BOMProductId */], 'not in', [this.options.hideProductBOMs]]);
            return true;
           
        }
        
    }

    export interface ProductBOMSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}